module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-info-finish-box",
    on: {
      "click": _vm.backBasic
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "basic-info-finish"
  }, [_c('img', {
    staticClass: "basic-info-finish-pic",
    attrs: {
      "src": _vm.photoUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basic-info-finish-detail"
  }, [_c('div', {
    staticClass: "basic-info-finish-name"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.truename))]), _vm._v(" "), _c('div', {
    staticClass: "personal-info",
    class: _vm.sexBoxClass
  }, [_c('i', {
    staticClass: "sex",
    class: _vm.sexClass
  }), _vm._v(" "), _c('span', {
    staticClass: "age"
  }, [_vm._v(_vm._s(_vm.age))])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info-finish-other"
  }, [_c('span', {
    staticClass: "save-edu"
  }, [_vm._v(_vm._s(_vm.educationText))]), _vm._v(" "), _c('span', {
    staticClass: "save-job"
  }, [_vm._v(_vm._s(_vm.workExperience))]), _vm._v(" "), _c('span', {
    staticClass: "save-phone"
  }, [_vm._v(_vm._s(_vm.mobile))])]), _vm._v(" "), (_vm.needEducation) ? _c('div', {
    staticClass: "basic-info-finish-edu"
  }, [_c('span', {
    staticClass: "edu-item"
  }, [_vm._v(_vm._s(_vm.getHighEdu.school))]), _vm._v(" "), _c('span', {
    staticClass: "edu-item"
  }, [_vm._v(_vm._s(_vm.getHighEdu.professional) + "专业")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-user-info-finish-tit"
  }, [_c('span', [_vm._v("个人资料")]), _vm._v(" "), _c('div', {
    staticClass: "modify"
  }, [_c('span', [_vm._v("修改")]), _vm._v(" "), _c('i', {
    staticClass: "icon-modify"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-458c257f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/expectation/basicInfo/index.vue
// module id = 346
// module chunks = 0